import { LoginApi } from '@/api';

/** 从 URL 读取企微 OAuth 回调 code（兼容 hash 路由：code 在 # 前的 search 中） */
export function getWxOAuthCodeFromUrl(): string | null {
	const fromSearch = new URLSearchParams(window.location.search).get('code');
	if (fromSearch) {
		return fromSearch;
	}
	const hash = window.location.hash;
	const queryIndex = hash.indexOf('?');
	if (queryIndex >= 0) {
		return new URLSearchParams(hash.slice(queryIndex + 1)).get('code');
	}
	return null;
}

/** 清除 URL 上的 code/state，避免重复换票 */
export function clearWxOAuthParamsFromUrl() {
	const url = new URL(window.location.href);
	url.searchParams.delete('code');
	url.searchParams.delete('state');
	const hash = url.hash;
	const queryIndex = hash.indexOf('?');
	if (queryIndex >= 0) {
		url.hash = hash.slice(0, queryIndex);
	}
	window.history.replaceState({}, '', url.toString());
}

/** 跳转企业微信官方网页授权（授权地址由后端根据 yml 配置生成） */
export async function redirectToWxWorkOAuth(state?: string) {
	const res = await LoginApi.getWxOAuthUrl(state);
	if (res?.code === 200 && res.data) {
		window.location.href = res.data as string;
		return;
	}
	throw new Error(res?.msg || '获取企业微信授权地址失败，请检查后端 wechat.oauth 配置');
}
